import AbsComponent from "./AbsComponent";
import CharLoadData from "./character/CharLoadData";
import CharHeader from "./character/CharHeader";
import CharInfo from './character/CharInfo';
import Equipments from "./character/Equipments";
import AbilitiesPoint from "./character/AbilitiesPoint";
import Abilities from "./character/Abilities";
import CharHeaderButtons from "./character/CharHeaderButtons";
import PointAbilityLayer from "./PointAbilityLayer";

export default class CharMain extends AbsComponent{
    constructor(_name='', _store={}, _actions={}, _router={}, _el='', _l10n={}){
        super(_name, _store, _actions, _router, _el, _l10n);

        this.charDataLoader = new CharLoadData(_store);
        
        this.header = new CharHeader('CharHeader', this.store, this.actions, this.router, '', _l10n);
        this.headerBtns = new CharHeaderButtons('CharHeaderButtons', this.store, this.actions, this.router, '', _l10n);
        this.info = new CharInfo('CharInfo', this.store, this.actions, this.router, '', _l10n);
        this.equip = new Equipments('Equipments', this.store, this.actions, this.router, '', _l10n);
        this.abilitiesPoint = new AbilitiesPoint('AbilitiesPoint', this.store, this.actions, this.router, '.contents-wrap > .info-ability', _l10n);
        this.abilities = new Abilities('Abilities', this.store, this.actions, this.router, '', _l10n);
        this.pointAbilityLayer = new PointAbilityLayer('PointAbilityLayer', this.store, this.actions, this.router, '', _l10n);
        
        this.addEventsOne();

        const watchCh = this.watch(this.store.getState, 'char', this.isEqual);
        this.store.subscribe( watchCh( this.loadAllowed.bind(this) ) );
    }

    loadAllowed(){
        if ($('html').attr('lang')==='cn') {
            axios( {
                method: 'GET',
                url: `${this.store.getState().config.apiDomain}/ingame/api/character/allowed.json`,
                params: {c:this.store.getState().char}
            })
            .then( (_res) => {
                console.log('------allowed-------', _res.data.allowed);
                this.store.dispatch(this.actions.setIsAllowed(_res.data.allowed));
                this.loadData();
            })
            .catch( (error) => {
                console.log( 'error---', error.response );
            })
            
        }else{
            this.loadData();
        }
    }

    loadData(_newVal, _oldVal, _path){
        const char = this.store.getState().char;

        this.charDataLoader.loadData(char, (_d)=>{
            let isCompare = (_d[0].data.id === window.myChar.id)? 'false': 'true';

            this.header.setting(_d[0], false, '.contents-wrap > section.header');
            this.headerBtns.setting(_d[0], '.contents-wrap > section.header');
            this.info.setting(_d[1], _d[0], '.contents-wrap > section.info-character');
            this.equip.setting(_d[1], isCompare, '.contents-wrap >');
            this.abilitiesPoint.setting(_d[2], '.contents-wrap > section.info-ability .btn-point-Ability');
            this.abilities.setting(_d[2], null, _d[0].data.clazz, '.contents-wrap > section.info-ability .ability-view');
            this.pointAbilityLayer.setting(_d[2], _d[3]);

            const charinfo = _d[0].data;

            this.store.dispatch(this.actions.setRecentChar({
                character_id: charinfo.id,
                server_id: charinfo.server_id,
                character_thumbnail: charinfo.profile_url,
                character_name: charinfo.name,
                job_name: charinfo.race_name,
                level: charinfo.level,
                mastery_level: charinfo.mastery_level,
                mastery_name: charinfo.mastery_faction_name,
                server_name: charinfo.server_name,
                clazz: charinfo.clazz,
            }));

            $('#myCharacterLayer').hide();
            $('#pointAbility').hide();
            $(".contents-wrap > .info-ability .btn-more").toggle(this.store.getState().isAllowed);
            this.AbilityViewFlag = false;
        });
    }

    addEventsOne(){
        // 능력치 정보 자세히 보기
        this.AbilityViewFlag = false;
        
        document.querySelector(".contents-wrap > .info-ability .btn-more").addEventListener('click', function(event) {
            event.preventDefault();
            const statTitles = document.querySelectorAll(".contents-wrap > .info-ability .stat-title");
            for (const statTitle of statTitles) {
                if(this.AbilityViewFlag) {
                    statTitle.classList.remove('is-active');
                } else {
                    statTitle.classList.add('is-active');
                }
            }
            this.AbilityViewFlag = !this.AbilityViewFlag ;
        });
    }

} // end of class